@if (element.data | removeAreaEmptyCategories:false:colors:element.strokeColors : loadedAllDataSubject| async; as widget) {
<app-mdr-title
    fontSize="16"
    class="dashboard-box-title d-flex m-b-20"
    >{{ element.title }}
    @if (widget.error) {
    <span
        class="ds-icon-error_outline fs-25 error-primary m-l-8"
        style="line-height: 0.8"
    ></span>
    }
</app-mdr-title>
@if (widget.data?.data.length && !widget.loading && !widget.hasNoResults) {
<ng-container class="m-t-30">
    @if (tableLegend && showLegend) {
    <div class="chart-legend d-flex-center">
        <app-mdr-dashboards-table
            [isChart]="true"
            id="{{ element.id }}_table_legend"
            [legend]="true"
            [bulletType]="bulletType"
            [element]="element"
            [dataSource]="calculateLegendTotal(widget.data?.data, element.strokeColors)"
            [displayedColumns]="legendDisplayedColumns"
        ></app-mdr-dashboards-table>
    </div>
    }
    <div
        [ngClass]="!tableLegend ? 'chart-main-flex' : 'chart-main m-t-30'"
        id="{{ element.id }}"
    >
        <apx-chart
            #chartRef
            [style]="{ width: width }"
            [series]="mapSeriesToFitContent(widget.data?.data)"
            [chart]="chartOptionsStackedArea.chart"
            [xaxis]="chartOptionsStackedArea.xaxis"
            [dataLabels]="chartOptionsStackedArea.dataLabels"
            [yaxis]="chartOptionsStackedArea.yaxis"
            [colors]="chartOptionsStackedArea.colors"
            [legend]="chartOptionsStackedArea.legend"
            [fill]="chartOptionsStackedArea.fill"
            [grid]="chartOptionsStackedArea.grid"
            [stroke]="chartOptionsStackedArea.stroke"
            [tooltip]="chartOptionsStackedArea.tooltip"
            [markers]="chartOptionsStackedArea.markers"
            [responsive]="chartOptionsStackedArea.responsive"
        ></apx-chart>
    </div>
    @if (!tableLegend && showLegend) {
    <div class="chart-custom-legend m-t-30">
        @for (category of calculateLegendTotal(widget.data?.data, element.strokeColors); track category) {
        <div class="gz-data-item-legend m-r-40 auto-width">
            <span
                [ngClass]="bulletType + '-bullet-legend'"
                [style.background]="category.color"
            ></span
            ><br />
            <div class="gz-data-item-legend--title letter-spacing-0">{{ category.name }} {{ category?.value ? ':' : '' }}</div>
            <div class="gz-data-item-legend--value letter-spacing-0">{{ category.value }}</div>
        </div>
        }
    </div>
    }
</ng-container>
} @if ((!widget.data?.data.length || !widget.data?.data) && !widget.loading && widget.error) {
<ng-container class="m-t-30">
    @if (tableLegend && showLegend) {
    <div class="chart-legend d-flex-center">
        <app-mdr-dashboards-table
            [isChart]="true"
            [legend]="true"
            id="{{ element.id }}_error"
            [bulletType]="bulletType"
            [dataSource]="element.noDataLegend"
            [displayedColumns]="legendDisplayedColumns"
        ></app-mdr-dashboards-table>
    </div>
    }
    <div [ngClass]="!tableLegend ? 'chart-main-flex' : 'chart-main m-t-30'">
        @if (emptyChartOptionsStackedArea) {
        <apx-chart
            #chartRef
            [style]="{ width: width }"
            [series]="emptyChartOptionsStackedArea.series"
            [chart]="emptyChartOptionsStackedArea.chart"
            [xaxis]="emptyChartOptionsStackedArea.xaxis"
            [dataLabels]="emptyChartOptionsStackedArea.dataLabels"
            [yaxis]="emptyChartOptionsStackedArea.yaxis"
            [colors]="emptyChartOptionsStackedArea.colors"
            [legend]="emptyChartOptionsStackedArea.legend"
            [fill]="emptyChartOptionsStackedArea.fill"
            [grid]="emptyChartOptionsStackedArea.grid"
            [stroke]="emptyChartOptionsStackedArea.stroke"
            [markers]="emptyChartOptionsStackedArea.markers"
            [responsive]="emptyChartOptionsStackedArea.responsive"
        ></apx-chart>
        }
    </div>
    @if (!tableLegend && showLegend) {
    <div class="chart-custom-legend m-t-30">
        @for (category of element.noDataLegend; track category) {
        <div class="gz-data-item-legend m-r-40 auto-width">
            <span
                [ngClass]="bulletType + '-bullet-legend'"
                [style.background]="category.color"
            ></span
            ><br />
            <div class="gz-data-item-legend--title letter-spacing-0">{{ category.name }} {{ category?.value ? ':' : '' }}</div>
            <div class="gz-data-item-legend--value letter-spacing-0">{{ category.value }}</div>
        </div>
        }
    </div>
    }
</ng-container>
} @if (widget.loading) {
<app-mdr-loader
    [ngClass]="widget.loading ? 'widget-empty' : 'widget-loading'"
    class="center-loader"
    [rows]="9"
    [columns]="1"
></app-mdr-loader>
} @if (widget.data?.data && !widget.loading && widget.hasNoResults) {
<app-empty-state
    i18n-title
    class="m-t-10 {{ className }}"
    [title]="emptyStateTitle"
    [subtitle]="emptyStateSubtitle"
    [className]="'area-chart'"
    type="noResults"
>
</app-empty-state>
}}
